import axios from "axios";

const AXIOS_API_TIMEOUT = 10000;
const apiClient = axios.create({
    timeout: AXIOS_API_TIMEOUT
})

export { apiClient };